var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "printWorkOrder" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form-inline",
          attrs: {
            model: _vm.form,
            size: "small",
            inline: "",
            "label-width": "90px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "设计工单ID", prop: "project_delivery_number" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "设计工单ID" },
                model: {
                  value: _vm.form.project_delivery_number,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "project_delivery_number", $$v)
                  },
                  expression: "form.project_delivery_number",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "制作状态", prop: "make_status" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.make_status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "make_status", $$v)
                    },
                    expression: "form.make_status",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "0", label: "待完善" } }),
                  _c("el-option", { attrs: { value: "1", label: "设计中" } }),
                  _c("el-option", { attrs: { value: "2", label: "印刷中" } }),
                  _c("el-option", { attrs: { value: "3", label: "已完成" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "印刷类型", prop: "print_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.print_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "print_type", $$v)
                    },
                    expression: "form.print_type",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "标准版" } }),
                  _c("el-option", { attrs: { value: "2", label: "个性化" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料类型", prop: "material_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.material_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "material_type", $$v)
                    },
                    expression: "form.material_type",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "PVC卡" } }),
                  _c("el-option", { attrs: { value: "2", label: "券" } }),
                  _c("el-option", { attrs: { value: "3", label: "卡套" } }),
                  _c("el-option", { attrs: { value: "4", label: "券套" } }),
                  _c("el-option", { attrs: { value: "5", label: "手提单" } }),
                  _c("el-option", { attrs: { value: "6", label: "宣传册" } }),
                  _c("el-option", { attrs: { value: "7", label: "画册" } }),
                  _c("el-option", { attrs: { value: "8", label: "其他" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商", prop: "supplier_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.supplier_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "supplier_id", $$v)
                    },
                    expression: "form.supplier_id",
                  },
                },
                _vm._l(_vm.supplierList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.supplier_name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "结算状态", prop: "settlement_status" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.settlement_status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "settlement_status", $$v)
                    },
                    expression: "form.settlement_status",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "0", label: "未结算" } }),
                  _c("el-option", { attrs: { value: "1", label: "结算中" } }),
                  _c("el-option", { attrs: { value: "3", label: "待付款" } }),
                  _c("el-option", { attrs: { value: "2", label: "已结算" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "印刷单ID", prop: "id" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "印刷单ID" },
                model: {
                  value: _vm.form.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "id", $$v)
                  },
                  expression: "form.id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "卡批次号", prop: "batch" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "卡批次号" },
                model: {
                  value: _vm.form.batch,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "batch", $$v)
                  },
                  expression: "form.batch",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "客户", prop: "customer_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    placeholder: "请选择",
                    "remote-method": _vm.remoteMethod,
                  },
                  model: {
                    value: _vm.form.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "customer_id", $$v)
                    },
                    expression: "form.customer_id",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.company_name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "订单号", prop: "order_id" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "订单号" },
                model: {
                  value: _vm.form.order_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "order_id", $$v)
                  },
                  expression: "form.order_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "销售负责人", prop: "user_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchSellUser,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchSellUser("")
                    },
                  },
                  model: {
                    value: _vm.form.user_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "user_id", $$v)
                    },
                    expression: "form.user_id",
                  },
                },
                _vm._l(_vm.personOptions.sellUser || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否加急", prop: "is_urgent" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.form.is_urgent,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "is_urgent", $$v)
                    },
                    expression: "form.is_urgent",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "是" } }),
                  _c("el-option", { attrs: { value: "0", label: "否" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "无效/有效", prop: "status" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "有效" } }),
                  _c("el-option", { attrs: { value: "0", label: "无效" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "印刷城市", prop: "city" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    placeholder: "请选择",
                    multiple: "",
                    clearable: "",
                    filterable: "",
                    "collapse-tags": "",
                  },
                  model: {
                    value: _vm.form.city,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "city", $$v)
                    },
                    expression: "form.city",
                  },
                },
                _vm._l(_vm.cityOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: item.id, label: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "设计稿数" } },
            [
              _c("el-input", {
                staticStyle: { width: "74px" },
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.form.start_num,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "start_num", $$v)
                  },
                  expression: "form.start_num",
                },
              }),
              _vm._v(" - "),
              _c("el-input", {
                staticStyle: { width: "74px" },
                attrs: { clearable: "", placeholder: "请输入" },
                model: {
                  value: _vm.form.end_num,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "end_num", $$v)
                  },
                  expression: "form.end_num",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "制卡状态", prop: "card_make_status" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择",
                    multiple: "",
                    "collapse-tags": "",
                  },
                  model: {
                    value: _vm.form.card_make_status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "card_make_status", $$v)
                    },
                    expression: "form.card_make_status",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "-1", label: "未创建" } }),
                  _c("el-option", { attrs: { value: "0", label: "待审核" } }),
                  _c("el-option", { attrs: { value: "1", label: "已审批" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "创建时间", prop: "create_time" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "220px" },
                attrs: {
                  "prefix-icon": "",
                  type: "daterange",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.create_time,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "create_time", $$v)
                  },
                  expression: "form.create_time",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.search },
                },
                [_vm._v("搜索")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.clearForm } },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "/cardmake/card/export",
                      expression: "'/cardmake/card/export'",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-download",
                  },
                  on: { click: _vm.exportPrinting },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": { background: "#F1F1F1", color: "#333333" },
            data: _vm.dataList,
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "基本信息", prop: "settle_amount", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _vm._v(" 设计工单ID："),
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "0" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.viewProjectDetail(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.project_delivery_number || "-")
                            ),
                          ]
                        ),
                        scope.row.project_delivery_status_des
                          ? _c("span", [
                              _vm._v(
                                "（" +
                                  _vm._s(
                                    scope.row.project_delivery_status_des || "-"
                                  ) +
                                  "）"
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        style: {
                          color:
                            scope.row.print_type === "1"
                              ? "#67C23A"
                              : "#F56C6C",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.print_type_str) +
                            " - " +
                            _vm._s(scope.row.material_type_str) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      [
                        _vm._v(" 制卡批次： "),
                        scope.row.batch
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddCard(scope.row, "view")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.batch))]
                            )
                          : _c("span", [_vm._v(_vm._s("-"))]),
                        scope.row.card_make_status_des
                          ? _c(
                              "span",
                              {
                                staticStyle: { "margin-left": "5px" },
                                style: {
                                  color: [0, 10].includes(
                                    scope.row.card_make_status
                                  )
                                    ? "red"
                                    : "",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.card_make_status_des || "-")
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", [_vm._v("印刷单ID：" + _vm._s(scope.row.id))]),
                    _c("div", [
                      _vm._v(
                        " （" +
                          _vm._s(scope.row.supplier_id) +
                          "）" +
                          _vm._s(scope.row.supplier_name) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v("印刷城市：" + _vm._s(scope.row.city_name)),
                    ]),
                    _c("div", [
                      _vm._v("卡序号起：" + _vm._s(scope.row.begin_code)),
                    ]),
                    _c("div", [
                      _vm._v("卡序号止：" + _vm._s(scope.row.end_code)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "关联信息", prop: "settle_amount", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _vm._v(
                          " 客户：" + _vm._s(scope.row.customer_name) + " "
                        ),
                        scope.row.customer_name.indexOf("*") != -1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewAllCompany(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", [
                      _vm._v("销售负责人：" + _vm._s(scope.row.username)),
                    ]),
                    _c(
                      "div",
                      [
                        _vm._v(" 关联卡订单号："),
                        _vm._l(scope.row.order_id, function (i, k) {
                          return _c(
                            "span",
                            {
                              key: k,
                              staticStyle: {
                                color: "#0f9df7",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.goOrderList(i)
                                },
                              },
                            },
                            [
                              i !== "0"
                                ? _c("span", [_vm._v(_vm._s(i) + "；")])
                                : _vm._e(),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _c("div", [
                      _vm._v(
                        "售卡数：" + _vm._s(scope.row.total_card_sale_num)
                      ),
                    ]),
                    _c("div", [
                      _vm._v("退卡数：" + _vm._s(scope.row.refund_number)),
                    ]),
                    _c("div", [
                      _vm._v("实售卡数：" + _vm._s(scope.row.card_sale_num)),
                    ]),
                    _c("div", [
                      _vm._v(
                        "订单金额：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.shou_money))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "已售金额：" +
                          _vm._s(
                            _vm._f("moneyFormat")(scope.row.card_sale_money)
                          )
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "回款金额：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.finance_money))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "制作费用",
              prop: "settle_amount",
              align: "left",
              width: "180px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "印刷费用（含运费）：" + _vm._s(scope.row.total_money)
                      ),
                    ]),
                    _c("div", [_vm._v("数量：" + _vm._s(scope.row.number))]),
                    _c("div", [
                      _vm._v(
                        "单价：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.price))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "快递费：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.express_fee))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "印刷费：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.print_money))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "公司承担：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.company_money))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "销售承担：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.person_money))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "优惠金额：" +
                          _vm._s(_vm._f("moneyFormat")(scope.row.coupon_cost))
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " 应付供应商金额：" +
                          _vm._s(
                            _vm._f("moneyFormat")(scope.row.real_supplier_money)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "设计稿", width: "130px", prop: "goods_name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.design_img && scope.row.design_img.length > 0
                      ? [
                          _vm.getFirstImage(scope.row.design_img)
                            ? [
                                _c("el-image", {
                                  staticStyle: {
                                    height: "50px",
                                    width: "70px",
                                  },
                                  attrs: {
                                    "preview-src-list": _vm.getImageList(
                                      scope.row.design_img
                                    ),
                                    src: _vm.getFirstImage(
                                      scope.row.design_img
                                    ),
                                    fit: "contain",
                                  },
                                }),
                              ]
                            : [
                                _vm.isPDF(scope.row.design_img[0])
                                  ? [
                                      _c("img", {
                                        staticStyle: {
                                          height: "70px",
                                          width: "50px",
                                        },
                                        attrs: {
                                          src: require("@/icons/svg/pdf.png"),
                                        },
                                      }),
                                    ]
                                  : _vm.isAI(scope.row.design_img[0])
                                  ? [
                                      _c("img", {
                                        staticStyle: {
                                          height: "70px",
                                          width: "50px",
                                        },
                                        attrs: {
                                          src: require("@/icons/svg/ai.png"),
                                        },
                                      }),
                                    ]
                                  : [
                                      _c("img", {
                                        staticStyle: {
                                          height: "70px",
                                          width: "50px",
                                        },
                                        attrs: {
                                          src: require("@/icons/svg/icon_psd.png"),
                                        },
                                      }),
                                    ],
                              ],
                        ]
                      : _vm._e(),
                    scope.row.design_img && scope.row.design_img.length > 0
                      ? _c("div", [
                          _vm._v(
                            " 共上传" +
                              _vm._s(scope.row.design_img.length) +
                              "张设计稿 "
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "importFile",
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.uploadFile(scope.row)
                          },
                        },
                      },
                      [_vm._v("上传设计稿")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "settle_amount",
              align: "left",
              width: "180px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _vm._v(" 制作状态： "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.make_status === "1"
                                  ? "danger"
                                  : scope.row.make_status === "2"
                                  ? "warning"
                                  : "success",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.make_status_str))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "6px" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(
                                  scope.row,
                                  "make_status"
                                )
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _vm._v(" 结算状态： "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.settlement_status === "1"
                                  ? "danger"
                                  : "success",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.settlement_status_str))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _vm._v(
                          " 有效/无效：" + _vm._s(scope.row.status_str) + " "
                        ),
                        scope.row.settlement_status === "0"
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "6px" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeStatus(scope.row, "status")
                                  },
                                },
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    scope.row.settlement_id !== 0
                      ? _c("div", [
                          _vm._v(
                            " 结算单ID：" +
                              _vm._s(scope.row.settlement_id) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _c("div", [
                      _vm._v(
                        "供应商邮件发送：" +
                          _vm._s(scope.row.send_email_num) +
                          " 次"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间-修改时间-修改人",
              prop: "make_count",
              align: "left",
              width: "220px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v("创建时间：" + _vm._s(scope.row.create_time)),
                    ]),
                    _c("div", [
                      _vm._v("修改时间：" + _vm._s(scope.row.update_time)),
                    ]),
                    _c("div", [
                      _vm._v("创建人： " + _vm._s(scope.row.add_username)),
                    ]),
                    _c("div", [
                      _vm._v("修改人： " + _vm._s(scope.row.last_username)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "120px",
              prop: "offline_gather_amount_rate",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.button.card_make_show == 2
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { margin: "0 5px 0 0" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAddCard(scope.row, "edit")
                              },
                            },
                          },
                          [_vm._v("添加制卡")]
                        )
                      : _vm._e(),
                    scope.row.button.edit_show == 2
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { margin: "0 5px 0 0" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openPrintingRecordDrawer(
                                  scope.row,
                                  "edit"
                                )
                              },
                            },
                          },
                          [_vm._v("编辑印刷单")]
                        )
                      : _vm._e(),
                    scope.row.button.perfect_show != 0
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { margin: "0 5px 0 0" },
                            attrs: {
                              disabled: [1].includes(
                                scope.row.button.perfect_show
                              ),
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openPrintingRecordDrawer(
                                  scope.row,
                                  "edit"
                                )
                              },
                            },
                          },
                          [_vm._v("完善印刷单")]
                        )
                      : _vm._e(),
                    _vm.$hasBtnRoles("/cardmake/card/send-email") &&
                    scope.row.button.send_show == 2
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { margin: "0 5px 0 0" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.sendSupplier(scope.row)
                              },
                            },
                          },
                          [_vm._v("发送给供应商")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "20px 0" } },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next, jumper",
              "page-size": 20,
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.currentPage,
            },
            on: { "current-change": _vm.currentChange },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改状态",
            visible: _vm.dialogStatusVisible,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogStatusVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "dialogStatusForm", attrs: { model: _vm.ruleForm } },
            [
              _vm.statusType === "make_status"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "制作状态",
                        prop: "make_status",
                        rules: [
                          {
                            required: true,
                            trigger: "change",
                            message: "请选择",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.make_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "make_status", $$v)
                            },
                            expression: "ruleForm.make_status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("设计中"),
                          ]),
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("待完善"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("印刷中"),
                          ]),
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("已完成"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.statusType === "settlement_status"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "结算状态",
                        prop: "settlement_status",
                        rules: [
                          {
                            required: true,
                            trigger: "change",
                            message: "请选择",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.settlement_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "settlement_status", $$v)
                            },
                            expression: "ruleForm.settlement_status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("未结算"),
                          ]),
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("待结算"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("已结算"),
                          ]),
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("待付款"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.statusType === "status"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "有效/无效",
                        prop: "status",
                        rules: [
                          {
                            required: true,
                            trigger: "change",
                            message: "请选择",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("有效"),
                          ]),
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("无效"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogStatusVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitStatus } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("printing-upload-dialog", {
        ref: "printingUploadDialog",
        on: { emitGet: _vm.emitGet },
      }),
      _c("send-supplier-dialog", {
        ref: "sendSupplierDialog",
        on: { sendSuccess: _vm.sendSuccess },
      }),
      _c("AddCardDialog", {
        ref: "addCardDialog",
        on: { success: _vm.handleAddCardSuccess },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发送给供应商",
            visible: _vm.dialogExportVisible,
            width: "40%",
            "append-to-body": "",
            "before-close": _vm.handleExportClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogExportVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "font-weight": "bold" } },
            [_vm._v("绑卡二维码")]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "1" },
              model: {
                value: _vm.has_wx_account,
                callback: function ($$v) {
                  _vm.has_wx_account = $$v
                },
                expression: "has_wx_account",
              },
            },
            [_vm._v("微信扫码先关注公众号")]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "0" },
              model: {
                value: _vm.has_wx_account,
                callback: function ($$v) {
                  _vm.has_wx_account = $$v
                },
                expression: "has_wx_account",
              },
            },
            [_vm._v("微信扫码直接绑卡")]
          ),
          _vm.row.group_id == 3
            ? _c(
                "el-radio",
                {
                  attrs: { label: "2" },
                  model: {
                    value: _vm.has_wx_account,
                    callback: function ($$v) {
                      _vm.has_wx_account = $$v
                    },
                    expression: "has_wx_account",
                  },
                },
                [_vm._v("微信-礼包直兑")]
              )
            : _vm._e(),
          _vm.row.purpose == 1
            ? _c(
                "el-radio",
                {
                  attrs: { label: "3" },
                  model: {
                    value: _vm.has_wx_account,
                    callback: function ($$v) {
                      _vm.has_wx_account = $$v
                    },
                    expression: "has_wx_account",
                  },
                },
                [_vm._v("钉钉扫码绑卡")]
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { margin: "20px 0", "font-weight": "bold" } },
            [_vm._v("支付码")]
          ),
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.yl88,
                callback: function ($$v) {
                  _vm.yl88 = $$v
                },
                expression: "yl88",
              },
            },
            [
              _c("el-checkbox", { attrs: { label: "1" } }, [
                _vm._v("YL88付款码链接"),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogExportVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmExport },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.printingRecordDrawer.visible,
            direction: "rtl",
            size: "88%",
            "destroy-on-close": "",
            "custom-class": "myDrawer",
            "append-to-body": true,
            title:
              _vm.printingRecordDrawer.params.type === "add"
                ? "添加印刷单"
                : "编辑印刷单",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.printingRecordDrawer, "visible", $event)
            },
            close: function ($event) {
              _vm.printingRecordDrawer.visible = false
            },
          },
        },
        [
          _vm.printingRecordDrawer.visible
            ? _c("CreatePrintingRecord", {
                attrs: { "drawer-params": _vm.printingRecordDrawer.params },
                on: {
                  close: function ($event) {
                    _vm.printingRecordDrawer.visible = false
                  },
                  success: _vm.handlePrintingRecordSuccess,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.applyFormVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "80%",
            title: _vm.drawerTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyFormVisible = $event
            },
          },
        },
        [
          _c("applyForm", {
            attrs: {
              visible: _vm.applyFormVisible,
              type: _vm.applyFormType,
              id: _vm.selectedId,
              projectType: _vm.selectedProjectType,
              projectStatus: _vm.selectedProjectStatus,
            },
            on: {
              "update:visible": function ($event) {
                _vm.applyFormVisible = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }